import {Injectable}                                                  from '@angular/core';
import {CrudPathDict, MedsConfIntf, MedsListIntf, MedsRecordLogIntf} from '@djsharkk/logr-types';
import {BehaviorSubject}                                             from 'rxjs';
import {DataFirebaseBase}                                            from './data-firebase.base';

@Injectable({
				providedIn: 'root'
			})
export class DataMedsService extends DataFirebaseBase<MedsRecordLogIntf> {
	protected override paths: CrudPathDict = {
		log: 'meds_records_log',
		sum: undefined
	};

	medsList = new BehaviorSubject<MedsListIntf[]>([])
	medsConf = new BehaviorSubject<MedsConfIntf[]>([])

	constructor() {
		super();
		this.svcFirebaseTools.recFetch<MedsListIntf>('meds_list').subscribe(data => this.medsList.next(data))
		this.svcFirebaseTools.recFetch<MedsConfIntf>('meds_conf').subscribe(data => this.medsConf.next(data))
	}


	getMedById(id: string) {
		return this.medsList.value.find(item => item.id === id)
	}


}
